export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Formula E - Season 10 Sustainability Report",
    "shortTitle": "",
    "description": "",
    "width": 1298,
    "height": 918,
    "currentLanguage": "EN",
    "languages": [
      {
        code: "EN",
        text: "English",
        href: "#"
      },
    ],
    "basePath": "/season10",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://sustainabilityreport.fiaformulae.com/season10/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '/season10/static/_content/formula-e-s10-sustainability-report.pdf',
      "printEnabled": false,
      "zoom": {
        "navEnabled": false,
        "sliderEnabled": true,
        "clickEnabled": true,
        "scrollEnabled": true,
      },
      "contents": {
        "enabled": true,
        "pinned": false,
        "numbers": true,
        "titles": true,
      },
      "languagesEnabled": false,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
      "fullscreenEnabled": true,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC 1-title" style="top:25px;left:-360px;" src="/season10/static/_content/1-title-1.png"/>
      <img class="abs halfScaleC 1-title" style="top:228px;left:-182px;" src="/season10/static/_content/1-title-2.png"/>
      <img class="abs halfScaleC 1-title" style="top:373px;left:-112px;" src="/season10/static/_content/1-title-3.png"/>
      <img class="abs halfScaleC 1-text" style="top:662px;left:836px;" src="/season10/static/_content/1-text-1.png"/>
      <img class="abs halfScaleC 1-logo" style="top:749px;left:-72px;" src="/season10/static/_content/logo.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("1-text"), 0.8, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)
          .fromTo(cOf("1-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "RACING FOR  FUTURES SEASON 10 Sustainability Report"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" onclick="Publish.goToPage(3);" style="top:170px; left:248px; width:390px; height:23px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(4);" style="top:193px; left:248px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(5);" style="top:214px; left:248px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:235px; left:248px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(8);" style="top:256px; left:248px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(9);" style="top:278px; left:248px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:300px; left:248px; width:390px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:411px; left:223px; width:413px; height:70px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:481px; left:246px; width:390px; height:20px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:502px; left:246px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:522px; left:246px; width:390px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:543px; left:246px; width:390px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:619px; left:246px; width:390px; height:70px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:690px; left:246px; width:390px; height:20px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(21);" style="top:709px; left:246px; width:390px; height:20px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:730px; left:246px; width:390px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:751px; left:246px; width:390px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:774px; left:246px; width:390px; height:22px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:170px; left:862px; width:355px; height:88px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:258px; left:892px; width:322px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:280px; left:892px; width:322px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:302px; left:892px; width:322px; height:22px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:396px; left:895px; width:325px; height:85px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:481px; left:895px; width:325px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:503px; left:895px; width:325px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(32);" style="top:524px; left:895px; width:325px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:544px; left:895px; width:325px; height:22px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:692px; left:905px; width:320px; height:24px;"></div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "CONTENTS  1 2 3 02  CONTENTS  INTRODUCTION  03  CEO Foreword A decade of progress Season 10 highlights in numbers Our sustainability strategy Season 10 stories Governance  04 05 07 08 09 12  FORMULA They pledge, we deliver The world’s fastest electric race car Underpinning our work On the global stage  13  14 15 17 18  FORMULA Human progress Empowering local communities Scaling up FIA Girls on Track Introducing Driving Force Creating opportunities within Formula E  19  20 21 22 23 24  4 5 6  SEASON 10 SUSTAINABILITY REPORT  FORMULA Refined and robust Our carbon impact Our reduction efforts  25 26 27 28  FORMULA Value through values Redefining the status quo A creative approach to impact Shaping sustainable cities  GRI INDEX  29  30 31 32 33  34"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": "1  INTRODUCTION"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg4Anim.stop();
        }
      `,
      "searchText": "CEO Season 10 of the ABB FIA Formula E World Championship was a landmark moment not just for electric motorsport, but for sustainable sport as a whole. As a sport with sustainability in our DNA, we’ve always known that our role extends far beyond racing. Our purpose is to accelerate sustainable human progress and this year, we took that mission to new heights. From cutting carbon through the use of sustainable aviation fuel across continents, to delivering local community impact through our Better Futures Fund, Season 10 saw us break new ground in every one of our four strategic pillars: Formula Excellence, Formula Equity, Formula Environment, and Formula Ecosystem. Together with our partners, teams, and host cities, we positively impacted more than 32,000 people through social projects,  04  INTRODUCTION  shipment, a pivotal step in decarbonising our global operations. We also retained our ISO 20121 certification, achieved the FIA’s Three-Star Environmental Accreditation, and strengthened alignment with ISO 14064 and IWA 42, reinforcing our climate governance and transparency. doubled participation in FIA Girls on Track, and launched Driving Force - a global sustainability education platform designed to inspire and empower the next generation. We also created a new “podium commitment” to ensure young women from every host market had a visible and meaningful role in each race. While only a small opportunity for them, it speaks volumes about our intent to open up our sport and include women in every part of our future. On the environmental front, we delivered measurable action and world-first innovation. We successfully relocated our global logistics hub to Valencia, enabling increased use of biofuel-powered sea freight in partnership with DHL. And as a motorsport-first, we were the first series to introduce Sustainable Aviation Fuel (SAF) for all championship freight between Berlin and Shanghai, reducing freight emissions by at least 80% on a 257-tonne  SEASON 10 SUSTAINABILITY REPORT  Perhaps most importantly, our efforts were recognised on the global stage. We were ranked number one in the Global Sustainability Benchmark in Sport for the second consecutive year, earning our best-ever score of 85%, and leading in every core category: Environmental (77%), Social (88%) and Governance (86%). This recognition is testament to the relentless dedication of the people behind this championship, on and off the track. At Formula E, we don’t see sustainability as a badge of honour or a finish line to cross. For us, it’s a constant pursuit. To go further, act faster, and always deliver more. While Season 10 was a record-breaking year, the next decade will be even more ambitious.  Jeff Dodds Chief Executive Officer, Formula E"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      
        <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
        
        `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg5Anim.stop();
        }
      `,
      "searchText": "A DECADE OF  PROGRESS For a decade, the ABB FIA Formula E World Championship has proven that a sport can deliver both electrifying entertainment and be a force for positive change. More than just a racing series, it stands for something bigger – using the platform of sport to drive progress for society.  In our first-ever Sustainability Report, we set out to be a “global leader” in innovative entertainment, bringing electric motorsport to city centres while using technology, sustainability and digital innovation to help tackle climate change.  It all started in March 2011, when then-FIA President Jean Todt and Formula E’s Founder Alejandro Agag sat down to map out what would become the world’s first all-electric single-seater championship. Their vision was as bold then as it is today: to race through the streets of the world’s most iconic cities with the best drivers and teams, showcasing the power and potential of sustainable mobility.  That ambition has only grown. Our vision remains the same at its core – refined into a simple yet powerful mission: to accelerate sustainable human progress through the power of electric racing.  It wasn’t just about great racing – it was about proving that electric vehicles could lead us toward a cleaner future.  05  INTRODUCTION  Although we are the world’s fastest-growing motorsport, Formula E is more than a championship; it’s a battle for the future. Our radical, all-electric race cars push the boundaries of innovation, driving forward the development of road car technology.  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click" style="top:227px;left:274px;" onclick="showSixPopOne()" src="/season10/static/_content/6-click-1.png"/>
      <div id="6-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 6-pop-1" style="top:70px;left:52px;" src="/season10/static/_content/6-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:89px;left:1188px;width:41px;height:42px;" onclick="hideOverlay('6-pop-1')"></div>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:191px;left:263px;" onclick="openPop('6-seasons', '6-season-1')" src="/season10/static/_content/6-click-1-1.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:238px;left:615px;" onclick="openPop('6-seasons', '6-season-2')" src="/season10/static/_content/6-click-1-2.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:271px;left:857px;" onclick="openPop('6-seasons', '6-season-3')" src="/season10/static/_content/6-click-1-3.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:495px;left:1090px;" onclick="openPop('6-seasons', '6-season-4')" src="/season10/static/_content/6-click-1-4.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:580px;left:770px;" onclick="openPop('6-seasons', '6-season-5')" src="/season10/static/_content/6-click-1-5.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:545px;left:644px;" onclick="openPop('6-seasons', '6-season-6')" src="/season10/static/_content/6-click-1-6.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:614px;left:270px;" onclick="openPop('6-seasons', '6-season-7')" src="/season10/static/_content/6-click-1-7.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:407px;left:394px;" onclick="openPop('6-seasons', '6-season-8')" src="/season10/static/_content/6-click-1-8.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 6-click-pop" style="top:494px;left:138px;" onclick="openPop('6-seasons', '6-season-9')" src="/season10/static/_content/6-click-1-9.png"/>

        <div id="6-season-1" class="6-seasons hidden noclick">
          <img class="abs halfScale 6-pop-1-1" style="top:225px;left:282px;" src="/season10/static/_content/6-pop-1-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:236px;left:616px;width:41px;height:42px;" onclick="closePop('6-season-1')"></div>
        </div>

        <div id="6-season-2" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-2" style="top:272px;left:634px;" src="/season10/static/_content/6-pop-1-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:283px;left:1023px;width:41px;height:42px;" onclick="closePop('6-season-2')"></div>
        </div>

        <div id="6-season-3" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-3" style="top:305px;left:876px;" src="/season10/static/_content/6-pop-1-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:316px;left:1177px;width:41px;height:42px;" onclick="closePop('6-season-3')"></div>
        </div>

        <div id="6-season-4" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-4" style="top:531px;left:808px;" src="/season10/static/_content/6-pop-1-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:542px;left:821px;width:41px;height:42px;" onclick="closePop('6-season-4')"></div>
        </div>

        <div id="6-season-5" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-5" style="top:613px;left:789px;" src="/season10/static/_content/6-pop-1-5.png"/>
          <div class="abs contentLinkNone pointer" style="top:624px;left:1167px;width:41px;height:42px;" onclick="closePop('6-season-5')"></div>
        </div>

        <div id="6-season-6" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-6" style="top:580px;left:663px;" src="/season10/static/_content/6-pop-1-6.png"/>
          <div class="abs contentLinkNone pointer" style="top:590px;left:1079px;width:41px;height:42px;" onclick="closePop('6-season-6')"></div>
        </div>

        <div id="6-season-7" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-7" style="top:463px;left:289px;" src="/season10/static/_content/6-pop-1-7.png"/>
          <div class="abs contentLinkNone pointer" style="top:477px;left:790px;width:41px;height:42px;" onclick="closePop('6-season-7')"></div>
        </div>

        <div id="6-season-8" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-8" style="top:443px;left:413px;" src="/season10/static/_content/6-pop-1-8.png"/>
          <div class="abs contentLinkNone pointer" style="top:455px;left:786px;width:41px;height:42px;" onclick="closePop('6-season-8')"></div>
        </div>

        <div id="6-season-9" class="6-seasons hidden noclick ">
          <img class="abs halfScale 6-pop-1-9" style="top:529px;left:156px;" src="/season10/static/_content/6-pop-1-9.png"/>
          <div class="abs contentLinkNone pointer" style="top:540px;left:551px;width:41px;height:42px;" onclick="closePop('6-season-9')"></div>
        </div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          
          setTimeout(function(){
            addContentLinks();
          },1000)
        }


        function openPop(klass, id) {
        popups = cOf(klass);
        ele = idOf(id);
        for(var i=0; i<popups.length; i++) {
          popups[i].className = "6-seasons hidden noclick";
          }
          ele.className = 'visible'
        }

        function closePop(id) {
          ele = idOf(id);
        ele.className = '6-seasons hidden noclick'
        }

        function showSixPopOne() {
          showOverlay('6-pop-1')
        }

        function closeSixPopOne() {
          hideOverlay('6-pop-1')
        }

        function onPageLeave() {
          pg6Anim.stop();
          closeSixPopOne();
        }

      `,
      "searchText": "A DECADE OF  PROGRESS (CONTINUED)  And the impact goes beyond the track. Over the years, we’ve forged lasting partnerships with host cities, suppliers and commercial partners, setting new standards for sustainability in sport. Whether reducing the carbon impact of logistics with DHL or breaking down barriers through the FIA Girls on Track programme, we’re redefining what it means to be a purpose-driven sport.  INTRODUCTION  The ABB FIA Formula E World Championship is the only all-electric World Championship sanctioned  CLICK TO READ ABOUT OUR 10 YEAR JOURNEY  by the Fédération Internationale de l’Automobile (FIA) and the fastest-growing motorsport series in the world. Over the past decade, it has showcased cuttingedge sustainable mobility technology, completing 10 seasons of racing through the heart of the world’s most iconic cities. This report highlights Formula E’s sustainability progress during Season 10, which ran from January  Formula E is a young sport with huge opportunities to grow and stay at the forefront of sustainable innovation. This Season 10 Sustainability Report highlights our latest progress and offers a glimpse of what the next decade may bring.  06  ABOUT FORMULA E AND THE SEASON 10 SUSTAINABILITY REPORT  to July 2024.  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:240px;left:536px; font-size: 3.3em; font-weight: 300; color: #00f5ff; padding: 0px; margin: 0px;"  data-number=' {"to": 55, "append": "%"}' ></h1>

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:324px;left:254px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3}' ></h1>

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:487px;left:989px; font-size: 3.5em; font-weight: 300; color: #00f5ff; padding: 0px; margin: 0px;"  data-number=' {"to": 25254, "comma": true}' ></h1>

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:469px;left:168px; font-size: 2.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 75000, "preppend": "€", "comma" : true}' ></h1>

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:661px;left:69px; font-size: 3.3em; font-weight: 300; color: #00f5ff; padding: 0px; margin: 0px;"  data-number=' {"to": 4}' ></h1>

      <h1 id="7-no" class="abs feSans-maxiExtraBd 7-no" style="top:636px;left:537px; font-size: 3.5em; font-weight: 300; color: #00f5ff; padding: 0px; margin: 0px;"  data-number=' {"to": 2000, "comma" : true}' ></h1>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(cOf("7-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[0])}}, 1)
          .fromTo(cOf("7-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[1])}}, 1.2)
          .fromTo(cOf("7-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[2])}}, 1.3)
          .fromTo(cOf("7-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[3])}}, 1.4)
          .fromTo(cOf("7-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[4])}}, 1.5)
          .fromTo(cOf("7-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[5])}}, 1.6);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg7Anim.stop();
          resetNumbers("7-no");
        }
      `,
      "searchText": "SEASON 10 HIGHLIGHTS  IN NUMBERS 65% 4  launched  host cities Berlin  Shanghai  €100,000 distributed  Portland  4  Change. Accelerated. Live summits  07  INTRODUCTION  London  Driving Force sustainability education programme launched  reduction in Scope 1 and 2 greenhouse gas emissions compared with Season 5 baseline  GEN3 EVO  25,254  the world’s most sustainable racing car and fastest electric car – introduced  people positively impacted by our social impact projects  2,000 FIA Girls on Track participants across all race locations  SEASON 10 SUSTAINABILITY REPORT  Certifications Recertified for ISO 20121 and FIA Three-Star Environmental Accreditation"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg8Anim.stop();
        }
      `,
      "searchText": "OUR SUSTAINABILITY  STRATEGY  The Formula E Sustainability Strategy is built on four key pillars, and the following chapters will highlight our achievements and milestones from Season 10.  FORMULA  Racing with purpose. Embedding sustainability at the heart of our corporate strategy through our brand authenticity plan.  FORMULA  Driving change in every host city by engaging with underrepresented communities, creating inclusive opportunities and leaving a lasting legacy.  FORMULA  Consistently improving carbon management and sustainability operations to minimise our environmental impact.  FORMULA 08  INTRODUCTION  Creating value through sustainability-driven collaborations that benefit all stakeholders.  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 9-click" style="top:737px;left:-79px;" onclick="showNinePopOne()" src="/season10/static/_content/9-click-1.png"/>
      <div id="9-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 9-pop-1" style="top:291px;left:56px;" src="/season10/static/_content/9-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:759px;left:56px;width:272px;height:42px;" onclick="hideOverlay('9-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showNinePopOne() {
          showOverlay('9-pop-1')
        }

        function closeNinePopOne() {
          hideOverlay('9-pop-1')
        }

        function onPageLeave() {
          pg9Anim.stop();
          closeNinePopOne();
        }
      `,
      "searchText": "SEASON 10  STORIES SUSTAINABLE, INNOVATIVE, EXCITING In a world where energy is scarce and costly, we’ve made efficiency a competitive element, adding to the excitement of our sport.  374M fans globally  When our drivers leave the garage and hit the track, they start with just 60% of the battery power needed to complete the race. Energy management isn’t just a consideration; it’s a crucial element of race strategy. Push too hard too soon, and they risk running out of power before the finish line, let alone competing for the podium. But those who master the art of efficiency – maximising regeneration through smart driving – give themselves the best shot at victory.  CLICK TO READ MORE  09  INTRODUCTION  23%  increase in worldwide fans (vs Season 9)  Gen3 Evo car  118m in China 27m in Indonesia 11m in Brazil  Engagement growth  20%  30% faster than a current F1 car  TWICE as innovative as F1 – fans’ perception of Formula E  SEASON 10 SUSTAINABILITY REPORT  growth in social media following (1bn impression)  147% growth in video views  40M highest-ever race audience (Monaco)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC cities-click" style="top:392px;left:891px;" src="/season10/static/_content/10-line.png"/>
      <img class="abs halfScaleC cities-click" style="top:521px;left:864px;" src="/season10/static/_content/10-click.png"/>

      <!-- POP 1 -->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 10-click" style="top:532px;left:938px;" onclick="showTenPopTwoOne()" src="/season10/static/_content/10-click-2.png"/>
      <div id="10-pop-2-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-2-1" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-2-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-2-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:1096px;width:131px;height:64px;" onclick="showTenPopTwoTwo('10-pop-2-2')"></div>
      </div>
      <div id="10-pop-2-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-2-2" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-2-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-2-2')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:953px;width:131px;height:64px;" onclick="showTenPopTwoOne('10-pop-2-1')"></div>
      </div>

      <!-- POP 2 -->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 10-click" style="top:616px;left:938px;" onclick="showTenPopThreeOne()" src="/season10/static/_content/10-click-3.png"/>
      <div id="10-pop-3-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-3-1" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-3-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-3-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:1096px;width:131px;height:64px;" onclick="showTenPopThreeTwo('10-pop-3-2')"></div>
      </div>
      <div id="10-pop-3-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-3-2" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-3-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-3-2')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:953px;width:131px;height:64px;" onclick="showTenPopThreeOne('10-pop-3-1')"></div>
      </div>

      <!-- POP 3 -->

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 10-click" style="top:700px;left:938px;" onclick="showTenPopFourOne()" src="/season10/static/_content/10-click-4.png"/>
      <div id="10-pop-4-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-4-1" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-4-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-4-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:1096px;width:131px;height:64px;" onclick="showTenPopFourTwo('10-pop-4-2')"></div>
      </div>
      <div id="10-pop-4-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 10-pop-4-2" style="top:45px;left:56px;" src="/season10/static/_content/10-pop-4-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('10-pop-4-2')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:953px;width:131px;height:64px;" onclick="showTenPopFourOne('10-pop-4-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.staggerFromTo(cOf("10-click"), 0.5, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1)
          .fromTo(cOf("cities-click"), 0.6, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)

          setTimeout(function(){
            addContentLinks();
          },1000)

        }

        function showTenPopOne() {
          showOverlay('10-pop-1')
        }

        function closeTenPopOne() {
          hideOverlay('10-pop-1')
        }

        function showTenPopTwoOne() {
          closeTenPopTwoTwo()
          showOverlay('10-pop-2-1')
        }

        function closeTenPopTwoOne() {
          hideOverlay('10-pop-2-1')
        }

        function showTenPopTwoTwo() {
          closeTenPopTwoOne()
          showOverlay('10-pop-2-2')
        }

        function closeTenPopTwoTwo() {
          hideOverlay('10-pop-2-2')
        }

        function showTenPopThreeOne() {
          closeTenPopThreeTwo()
          showOverlay('10-pop-3-1')
        }

        function closeTenPopThreeOne() {
          hideOverlay('10-pop-3-1')
        }

        function showTenPopThreeTwo() {
          closeTenPopThreeOne()
          showOverlay('10-pop-3-2')
        }

        function closeTenPopThreeTwo() {
          hideOverlay('10-pop-3-2')
        }

        function showTenPopFourOne() {
          closeTenPopFourTwo()
          showOverlay('10-pop-4-1')
        }

        function closeTenPopFourOne() {
          hideOverlay('10-pop-4-1')
        }

        function showTenPopFourTwo() {
          closeTenPopFourOne()
          showOverlay('10-pop-4-2')
        }

        function closeTenPopFourTwo() {
          hideOverlay('10-pop-4-2')
        }

        function onPageLeave() {
          pg10Anim.stop();
          closeTenPopOne();
          closeTenPopTwoOne();
          closeTenPopTwoTwo();
          closeTenPopThreeOne();
          closeTenPopThreeTwo();
          closeTenPopFourOne();
          closeTenPopFourTwo();
        }
      `,
      "searchText": "SEASON 10  STORIES A LASTING LEGACY IN HOST CITIES The Better Futures Fund was established in Season 10 to strengthen our local impact and ensure a lasting legacy in host cities, extending our commitment beyond race day. The fund supports local causes in key impact areas such as tackling inequality, protecting the environment and supporting communities. In Season 10, €100,000 was distributed equally among projects in the final four race locations – Berlin, Shanghai, Portland and London. These projects were selected through a robust selection process managed by Formula E. Beyond the financial support, we work with recipient organisations to increase awareness of their cause and engage meaningfully with them while we are in the city, including providing volunteer support from the Formula E ecosystem. Building on the success of the pilot, the Better Futures Fund was expanded to all race locations in Season 11.  10  INTRODUCTION  LONDON impact themes Empowering underserved communities Tackling inequalities Community engagement Environmental protection  SEASON 10 SUSTAINABILITY REPORT  CLICK TO VIEW HOST CITIES LEGACY STORIES  PORTLAND BERLIN SHANGHAI"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 11-click" style="top:737px;left:-80px;" onclick="showElevenPopOne()" src="/season10/static/_content/11-click.png"/>
      <div id="11-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 11-pop-1" style="top:291px;left:56px;" src="/season10/static/_content/11-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:759px;left:56px;width:272px;height:42px;" onclick="hideOverlay('11-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showElevenPopOne() {
          showOverlay('11-pop-1')
        }

        function closeElevenPopOne() {
          hideOverlay('11-pop-1')
        }

        function onPageLeave() {
          pg11Anim.stop();
          closeElevenPopOne();
        }
      `,
      "searchText": "SEASON 10  STORIES OPTIMISING OUR OPERATIONS WITH NEW VALENCIA HUB We made a significant operational shift with the relocation of our global logistics headquarters to the Circuit Ricardo Tormo in Valencia, Spain. This move, which replaced our previous base at Donington Park, UK, not only enhanced logistical efficiency but also reinforced our commitment to sustainability. The new location's proximity to a major port allowed us to optimise freight routes, significantly increasing the use of sustainable sea freight options. In partnership with DHL, we prioritised ships powered by sustainable biofuels. Relocation also marked the creation of a permanent test track and development centre, offering a dedicated space for testing, office operations and the development of both current and future electric vehicles.  CLICK TO READ MORE  11  INTRODUCTION  “  “Formula E is a brand that is linked to values that we share of sustainability and technological advance to reach a better future.” Vicente Barrera, Vice President, Generalitat Valenciana  ”  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg12Anim.stop();
        }
      `,
      "searchText": "GOVERNANCE We have a robust governance structure in place to ensure sustainability remains a core strategic priority of Formula E.  BOARD-LEVEL ENGAGEMENT AND OVERSIGHT Board-level oversight of climate-related issues at Formula E occurs on a case-bycase basis, addressing key matters as they arise. The Board holds ultimate responsibility for sustainability-related decision-making, reviewing strategy, overseeing major capital expenditures, guiding annual budgets and shaping innovation and R&D priorities.  12  INTRODUCTION  CEO ROLE IN CLIMATE LEADERSHIP Our CEO holds ultimate accountability for managing risks and opportunities, delegating responsibility for specific issues to the relevant departments.  STRATEGIC OVERSIGHT Our VP of Sustainability oversees the strategic assessment and management of risks and opportunities, integrating climate-related issues into Leadership Team meetings as needed to guide strategic, financial and operational planning.  MANAGEMENT SYSTEMS AND STANDARDS Our ISO 20121 Management System defines climate- and nature-related roles, responsibilities and actions across all levels of the business. Key responsibilities are integrated into job descriptions, and sustainability-related KPIs, including our science-based targets (SBTs), help drive decision-making to support emissions reductions. Additionally, Formula E undergoes assessment and scoring through the Carbon Disclosure Project (CDP), providing deeper insight into climate-related risks and opportunities relevant to our business model.  SEASON 10 SUSTAINABILITY REPORT  FINANCIAL INCENTIVES Sustainability is embedded in our business KPIs, providing clear priorities and performance expectations across the company. These KPIs also influence bonusrelated financial incentives for relevant employees."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg13Anim.stop();
        }
      `,
      "searchText": "2  FORMULA"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
       <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
       `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg14Anim.stop();
        }
      `,
      "searchText": "THEY PLEDGE, WE SETTING THE STANDARD FOR SUSTAINABILITY LEADERSHIP Sustainability, like sport, thrives on positive competition. At Formula E, that competition starts within. We constantly push ourselves to improve season after season. That drive for excellence is the foundation of our sustainability approach, supporting our pillars of equity, environment and ecosystem.  14  FORMULA EXCELLENCE  THIS SECTION OF THE REPORT We show how sustainability is fully embedded in our corporate strategy and highlight the key factors behind our success.  GEN3 EVO  SUSTAINABILITY  LEVERAGING  Our car sits at the  MANAGEMENT SYSTEM  OUR PLATFORM  heart of Formula E,  We integrate sustainability  We showcase  and this latest edition  into everyday operations and  sustainability  pushes the boundaries  strategic decisions, aligning  leadership through  of both performance  with ISO 20121 and the FIA  events and awards,  and sustainability like  Three-Star Environmental  setting new standards  never before.  Accreditation.  for excellence.  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 15-click" style="top:684px;left:251px;" onclick="showFifteenPopOne()" src="/season10/static/_content/15-click.png"/>
      <div id="15-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 15-pop-1" style="top:152px;left:52px;" src="/season10/static/_content/15-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:720px;left:83px;width:42px;height:42px;" onclick="hideOverlay('15-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showFifteenPopOne() {
          showOverlay('15-pop-1')
        }

        function closeFifteenPopOne() {
          hideOverlay('15-pop-1')
        }

        function onPageLeave() {
          pg15Anim.stop();
          closeFifteenPopOne();
        }

      `,
      "searchText": "THE WORLD’S  FASTEST ELECTRIC RACE CAR  The world’s most sustainable racing car is only truly viable if it also pushes the limits of speed and innovation.  of damage andminimising waste. Meanwhile, its tyres now contain 35% sustainable materials, up from 26% in the original Gen3.  Unveiled in Season 10, the Gen3 Evo accelerates from 0 to 60 km/h in just 1.82 seconds, 30% faster than a current Formula 1 car and 36% faster than the previous Gen3 car. It proves that sustainability and performance aren’t just compatible; when driven by technical and innovation excellence, sustainability can enhance performance.  LESS WASTE  with chassis redesign  Building on the circular design, high energy efficiency and sustainable batteries of the original Gen3, the Gen3 Evo introduces two key improvements. Its redesigned chassis is more robust and resilient, reducing the likelihood  15  FORMULA EXCELLENCE  35% CLICK TO READ ABOUT THE LIFE CYCLE OF GEN3  SEASON 10 SUSTAINABILITY REPORT  sustainable materials in tyres"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC click-box" style="top:324px;left:-208px;" src="/season10/static/_content/16-click.png"/>
      <img class="abs halfScaleC animatedpulse halfpulsetwo click-box" style="top:514px;left:58px;" src="/season10/static/_content/16-click-icon.png"/>
   
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 16-click-1" style="top:-9px;left:945px;" onclick="showSixteenPopOne()" src="/season10/static/_content/16-click-1.png"/>
      <div id="16-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 16-pop-1" style="top:75px;left:52px;" src="/season10/static/_content/16-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:84px;left:1023px;width:102px;height:102px;" onclick="hideOverlay('16-pop-1')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 16-click-2" style="top:264px;left:926px;" onclick="showSixteenPopTwo()" src="/season10/static/_content/16-click-2.png"/>
      <div id="16-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 16-pop-2" style="top:347px;left:51px;" src="/season10/static/_content/16-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:357px;left:1004px;width:102px;height:102px;" onclick="hideOverlay('16-pop-2')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 16-click-3" style="top:192px;left:643px;" onclick="showSixteenPopThree()" src="/season10/static/_content/16-click-3.png"/>
      <div id="16-pop-3" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 16-pop-3" style="top:276px;left:51px;" src="/season10/static/_content/16-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:285px;left:737px;width:102px;height:102px;" onclick="hideOverlay('16-pop-3')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 16-click-4" style="top:557px;left:670px;" onclick="showSixteenPopFour()" src="/season10/static/_content/16-click-4.png"/>
      <div id="16-pop-4" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 16-pop-4" style="top:451px;left:51px;" src="/season10/static/_content/16-pop-4.png"/>
        <div class="abs contentLinkNone pointer" style="top:650px;left:766px;width:102px;height:102px;" onclick="hideOverlay('16-pop-4')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
  
      `,
      "script": `
        function onPageEnter() {
        pg16Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showSixteenPopOne() {
          showOverlay('16-pop-1')
        }

        function closeSixteenPopOne() {
          hideOverlay('16-pop-1')
        }

        function showSixteenPopTwo() {
          showOverlay('16-pop-2')
        }

        function closeSixteenPopTwo() {
          hideOverlay('16-pop-2')
        }

        function showSixteenPopThree() {
          showOverlay('16-pop-3')
        }

        function closeSixteenPopThree() {
          hideOverlay('16-pop-3')
        }

        function showSixteenPopFour() {
          showOverlay('16-pop-4')
        }

        function closeSixteenPopFour() {
          hideOverlay('16-pop-4')
        }

        function onPageLeave() {
        pg16Anim.stop();
        closeSixteenPopOne();
        closeSixteenPopTwo();
        closeSixteenPopThree();
        closeSixteenPopFour();
        }

      `,
      "searchText": "THE WORLD’S  T Y RE E  F  FI  IN E R A L S  B AT T E R  Y  M  CIR C  UL  RACE CAR (CONTINUED)  E N CY CI  FASTEST ELECTRIC  A R D ES NS  C R  YC L E D EC  IB  G  SEASON 10 SUSTAINABILITY REPORT  ON F  E  FORMULA EXCELLENCE  RB  R  16  A  I  CLICK CIRCLES TO READ ABOUT ELEMENTS OF THE GEN3 CAR"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 17-click-1" style="top:591px;left:772px;" onclick="showSeventeenPopOne()" src="/season10/static/_content/17-click-1.png"/>
      <div id="17-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 17-pop-1" style="top:376px;left:862px;" src="/season10/static/_content/17-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:392px;left:1193px;width:41px;height:42px;" onclick="hideOverlay('17-pop-1')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 17-click-2" style="top:632px;left:772px;" onclick="showSeventeenPopTwo()" src="/season10/static/_content/17-click-2.png"/>
      <div id="17-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 17-pop-2" style="top:376px;left:862px;" src="/season10/static/_content/17-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:392px;left:1193px;width:41px;height:42px;" onclick="hideOverlay('17-pop-2')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showSeventeenPopOne() {
          showOverlay('17-pop-1')
        }

        function closeSeventeenPopOne() {
          hideOverlay('17-pop-1')
        }

        function showSeventeenPopTwo() {
          showOverlay('17-pop-2')
        }

        function closeSeventeenPopTwo() {
          hideOverlay('17-pop-2')
        }

        function onPageLeave() {
          pg17Anim.stop();
          closeSeventeenPopOne();
          closeSeventeenPopTwo();
        }
      `,
      "searchText": "UNDERPINNING OUR WORK  Our sustainability management system guides every operational and governance decision, with ISO 20121 at the heart of our strategy, driving continuous improvement. In Season 10, we strengthened our approach to carbon management, working closely with stakeholders to align with ISO 14064 for emissions monitoring and IWA 42 for net zero. This phased transition, built on collaboration, lays the foundation for more rigorous climate action. Our 18-month plan to implement the recently achieved BSI Net Zero Pathway was another key milestone, with partners helping to improve supply chain sustainability, event power management and waste reduction. We also reinforced compliance by integrating environmental, social and governance risks into a legal register covering all race locations. Establishing tailored regulations was a multi-season effort, but by Season 10, every site had a legal register in place.  17  FORMULA EXCELLENCE  Navigating different legal systems and cultural perspectives is a challenge, which is why we worked with local law firms to ensure compliance while maintaining a strong baseline standard, using UK law as a reference. A key focus for Season 10 was the structured integration of human rights considerations. In April 2024, ahead of the Paris Olympic and Paralympic Games, ISO 20121 was updated to strengthen focus areas including climate action and net zero, human and child rights, social impact, digital responsibility, mental health and supply chain sustainability. Our collaboration with UNICEF deepened our understanding of human and child rights, shaping our approach. Building on this, our VP of Sustainability, Julia Pallé, and Strategic Sustainability Advisor Pierluigi Zacheo contributed to drafting Annex D of the revised ISO 20121 standard, reinforcing these commitments. To further strengthen our human rights policy, we conducted a gap analysis and aligned with the UN Guiding Principles on  SEASON 10 SUSTAINABILITY REPORT  Business and Human Rights. This led to the introduction of our Anti-Slavery and Human Trafficking Policy, which was fully implemented in Season 11. Finally, in Season 10, we recertified for ISO 20121 and the FIA Three-Star Environmental Accreditation.  CLICK BELOW TO READ MORE ABOUT:  ISO 20121 FIA THREE STAR ENVIRONMENTAL ACCREDITATION"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 18-click-1" style="top:232px;left:853px;" onclick="showEighteenPopOne()" src="/season10/static/_content/18-click.png"/>
      <div id="18-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 18-pop-1" style="top:63px;left:50px;" src="/season10/static/_content/18-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:1188px;width:41px;height:42px;" onclick="hideOverlay('18-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg18Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)

        }

        function showEighteenPopOne() {
          showOverlay('18-pop-1')
        }

        function closeEighteenPopOne() {
          hideOverlay('18-pop-1')
        }

        function onPageLeave() {
        pg18Anim.stop();
          closeEighteenPopOne();
        }
      `,
      "searchText": "ON THE  GLOBAL STAGE  CLICK TO READ ABOUT OUR PURSUIT FOR IMPROVEMENT  New York Climate Week was a key moment in our calendar, with VP Sustainability Julia Pallé showcasing our work from September 23-26, 2024, alongside the UN General Assembly and leaders across business, politics and sustainability. Julia joined Hawazen Nassief, Acting Head of Sustainability at our partner and investor PIF, and Benjamin Camus, Director of Evolution Markets Corporate Environmental Solutions, to present our path to net zero. Throughout the week, we contributed to three additional panels on topics central to both our sustainability strategy and global decarbonisation efforts: EV infrastructure and the future of urban mobility, scaling climate technologies and net zero cities.  18  FORMULA EXCELLENCE  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg19Anim.stop();
        }
      `,
      "searchText": "3  FORMULA"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 20-click-1" style="top:672px;left:931px;" onclick="showTwentyPopOne()" src="/season10/static/_content/20-click.png"/>
      <div id="20-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 20-pop-1" style="top:690px;left:866px;" src="/season10/static/_content/20-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:687px;left:866px;width:195px;height:82px;" onclick="hideOverlay('20-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg20Anim = new TimelineMax();

        setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentyPopOne() {
          showOverlay('20-pop-1')
        }

        function closeTwentyPopOne() {
          hideOverlay('20-pop-1')
        }

        function onPageLeave() {
        pg20Anim.stop();
          closeTwentyPopOne();
        }
      `,
      "searchText": "HUMAN UPLIFTING COMMUNITIES AND BUILDING INCLUSIVE OPPORTUNITIES IN SEASON 10 Ahead of Season 10, we identified an opportunity to enhance the social dimension of our sustainability strategy. At the heart of Formula E’s purpose is accelerating sustainable human progress through electric racing, and we were determined to make the ‘human progress’ aspect a key strategic priority. For people to fully engage in climate action, they first need a sense of opportunity, autonomy and belonging in their own lives. Social and economic barriers often prevent communities from participating in or benefitting from the transition to a sustainable future. That’s why our focus in Season 10 – and beyond – is on uplifting communities, breaking down systemic barriers and creating inclusive opportunities. Our Social Impact Strategy is designed to ensure that every city we race in experiences meaningful, lasting change.  20  FORMULA EQUITY  THIS SECTION OF THE REPORT Explores the four core programmes driving that impact.  COMMUNITY  FIA GIRLS  BETTER  ENGAGEMENT  ON TRACK  FUTURES FUND  DRIVING FORCE  Involving local  Sparking the  Leaving a  Empowering  communities  next generation  lasting legacy  the next  with our races.  of women in  in host cities.  motorsport.  25,254 SEASON 10 SUSTAINABILITY REPORT  generation of changemakers.  people positively impacted by our Season 10 social impact projects"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale animatedpulse halfpulsetwo pointer 21-click-1" style="top:538px;left:51px;" onclick="showTwentyOnePopOne()" src="/season10/static/_content/21-click-1.png"/>
      <div id="21-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 21-pop-1" style="top:538px;left:52px;" src="/season10/static/_content/21-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:556px;left:71px;width:259px;height:41px;" onclick="hideOverlay('21-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:760px;left:716px;width:42px;height:42px;" onclick="hideOverlay('21-pop-1')"></div>
      </div>

      <img class="abs halfScale animatedpulse halfpulsetwo pointer 21-click-2" style="top:645px;left:51px;" onclick="showTwentyOnePopTwo()" src="/season10/static/_content/21-click-2.png"/>
      <div id="21-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 21-pop-2" style="top:170px;left:52px;" src="/season10/static/_content/21-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:731px;left:83px;width:42px;height:42px;" onclick="hideOverlay('21-pop-2')"></div>
      </div>

      <img class="abs halfScale animatedpulse halfpulsetwo pointer 21-click-3" style="top:736px;left:51px;" onclick="showTwentyOnePopThree()" src="/season10/static/_content/21-click-3.png"/>
      <div id="21-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 21-pop-3" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:88px;left:1190px;width:42px;height:42px;" onclick="hideOverlay('21-pop-3')"></div>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:366px;left:92px;" onclick="openPop('21-city', '21-city-1')" src="/season10/static/_content/21-clickcity-1.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:480px;left:120px;" onclick="openPop('21-city', '21-city-2')" src="/season10/static/_content/21-clickcity-2.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:465px;left:635px;" onclick="openPop('21-city', '21-city-3')" src="/season10/static/_content/21-clickcity-3.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:405px;left:561px;" onclick="openPop('21-city', '21-city-4')" src="/season10/static/_content/21-clickcity-4.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:396px;left:928px;" onclick="openPop('21-city', '21-city-5')" src="/season10/static/_content/21-clickcity-5.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:445px;left:827px;" onclick="openPop('21-city', '21-city-6')" src="/season10/static/_content/21-clickcity-6.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:354px;left:554px;" onclick="openPop('21-city', '21-city-7')" src="/season10/static/_content/21-clickcity-7.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:336px;left:439px;" onclick="openPop('21-city', '21-city-8')" src="/season10/static/_content/21-clickcity-8.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:612px;left:296px;" onclick="openPop('21-city', '21-city-9')" src="/season10/static/_content/21-clickcity-9.png"/>

        <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 21-click-pop" style="top:410px;left:420px;" onclick="openPop('21-city', '21-city-10')" src="/season10/static/_content/21-clickcity-10.png"/>

        <div id="21-city-1" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-1" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:569px;left:201px;width:41px;height:42px;" onclick="closePop('21-city-1')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-1')"></div>
        </div>

        <div id="21-city-2" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-2" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:732px;left:267px;width:41px;height:42px;" onclick="closePop('21-city-2')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-2')"></div>
        </div>

        <div id="21-city-3" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-3" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:692px;left:727px;width:41px;height:42px;" onclick="closePop('21-city-3')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-3')"></div>
        </div>

        <div id="21-city-4" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-4" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:709px;left:668px;width:41px;height:42px;" onclick="closePop('21-city-4')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-4')"></div>
        </div>

        <div id="21-city-5" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-5" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-5.png"/>
          <div class="abs contentLinkNone pointer" style="top:660px;left:984px;width:41px;height:42px;" onclick="closePop('21-city-5')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-5')"></div>
        </div>

        <div id="21-city-6" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-6" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-6.png"/>
          <div class="abs contentLinkNone pointer" style="top:671px;left:938px;width:41px;height:42px;" onclick="closePop('21-city-6')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-6')"></div>
        </div>

        <div id="21-city-7" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-7" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-7.png"/>
          <div class="abs contentLinkNone pointer" style="top:664px;left:665px;width:41px;height:42px;" onclick="closePop('21-city-7')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-7')"></div>
        </div>

        <div id="21-city-8" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-8" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-8.png"/>
          <div class="abs contentLinkNone pointer" style="top:557px;left:538px;width:41px;height:42px;" onclick="closePop('21-city-8')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-8')"></div>
        </div>

        <div id="21-city-9" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-9" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-9.png"/>
          <div class="abs contentLinkNone pointer" style="top:383px;left:431px;width:41px;height:42px;" onclick="closePop('21-city-9')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-9')"></div>
        </div>

        <div id="21-city-10" class="21-city hidden noclick">
          <img class="abs halfScale 21-pop-3-10" style="top:70px;left:50px;" src="/season10/static/_content/21-pop-3-10.png"/>
          <div class="abs contentLinkNone pointer" style="top:558px;left:535px;width:41px;height:42px;" onclick="closePop('21-city-10')"></div>
          <div class="abs contentLinkNone pointer" style="top:88px;left:1186px;width:41px;height:42px;" onclick="closePop('21-city-10')"></div>
        </div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg21Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentyOnePopOne() {
          showOverlay('21-pop-1')
        }

        function closeTwentyOnePopOne() {
          hideOverlay('21-pop-1')
        }

         function showTwentyOnePopTwo() {
          showOverlay('21-pop-2')
        }

        function closeTwentyOnePopTwo() {
          hideOverlay('21-pop-2')
        }

        function showTwentyOnePopThree() {
          showOverlay('21-pop-3')
        }

        function closeTwentyOnePopThree() {
          hideOverlay('21-pop-3')
        }

        function openPop(klass, id) {
        popups = cOf(klass);
        ele = idOf(id);
        for(var i=0; i<popups.length; i++) {
          popups[i].className = "21-city hidden noclick";
          }
          ele.className = 'visible'
        }

        function closePop(id) {
          ele = idOf(id);
        ele.className = '21-city hidden noclick'
        }

        function onPageLeave() {
          pg21Anim.stop();
          closeTwentyOnePopOne();
          closeTwentyOnePopTwo();
          closeTwentyOnePopThree();
        }
      `,
      "searchText": "EMPOWERING Through a strategic ‘theory of change’ process, we refined the core vision of our Formula Equity pillar – our social strategy – to better align with the impact we aim to create in our host cities.  LOCAL COMMUNITIES  Our work in this space has already reached over 3.5 million children through our partnership with UNICEF. Building on this foundation, the Community Engagement programme is designed to deepen our local relevance and leave a lasting legacy in each host city.  CLICK TO READ MORE  CLICK TO READ ABOUT COMMUNITY ENGAGEMENT CLICK TO READ OUR SEASON 10 HIGHLIGHTS  21  FORMULA EQUITY  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 22-click-1" style="top:462px;left:-81px;" onclick="showTwentyTwoPopOne()" src="/season10/static/_content/22-click-1.png"/>
      <div id="22-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 22-pop-1" style="top:483px;left:52px;" src="/season10/static/_content/22-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:485px;left:53px;width:259px;height:41px;" onclick="hideOverlay('22-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:765px;left:1231px;width:42px;height:42px;" onclick="hideOverlay('22-pop-1')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 22-click-2" style="top:702px;left:470px;" onclick="showTwentyTwoPopTwo()" src="/season10/static/_content/22-click-2.png"/>
      <div id="22-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 22-pop-2" style="top:50px;left:52px;" src="/season10/static/_content/22-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:744px;left:78px;width:42px;height:42px;" onclick="hideOverlay('22-pop-2')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 22-click-3" style="top:702px;left:818px;" onclick="showTwentyTwoPopThree()" src="/season10/static/_content/22-click-3.png"/>
      <img class="abs halfScale 22-img" style="top:681px;left:1129px;" src="/season10/static/_content/22-img.png"/>
      <div id="22-pop-3" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 22-pop-3" style="top:50px;left:52px;" src="/season10/static/_content/22-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:735px;left:1171px;width:42px;height:42px;" onclick="hideOverlay('22-pop-3')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg22Anim = new TimelineMax();

        setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentyTwoPopOne() {
          showOverlay('22-pop-1')
        }

        function closeTwentyTwoPopOne() {
          hideOverlay('22-pop-1')
        }

        function showTwentyTwoPopTwo() {
          showOverlay('22-pop-2')
        }

        function closeTwentyTwoPopTwo() {
          hideOverlay('22-pop-2')
        }

        function showTwentyTwoPopThree() {
          showOverlay('22-pop-3')
        }

        function closeTwentyTwoPopThree() {
          hideOverlay('22-pop-3')
        }

        function onPageLeave() {
          pg22Anim.stop();
          closeTwentyTwoPopOne();
          closeTwentyTwoPopTwo();
          closeTwentyTwoPopThree();
        }
      `,
      "searchText": "SCALING UP Formula E’s FIA Girls on Track expanded to all 11 race markets for the first time in Season 10, a major step up from five markets in Season 9.  FIA GIRLS ON TRACK  To support this growth, the programme underwent a full rebrand, adopting a youthful, disruptive and fun identity tailored to engage 12- to 18-year-olds.  CLICK TO READ MORE  2,000 95% 71%  participants in Season 10  felt inspired by the women they met in motorsport  of participants interested in pursuing STEM subjects after attending  22  FORMULA EQUITY  CLICK TO READ ABOUT GIRLS ON TRACK  SEASON 10 SUSTAINABILITY REPORT  CLICK TO READ AISHA'S STORY"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale animatedpulse halfpulsetwo pointer 23-click-1" style="top:538px;left:51px;" onclick="showTwentyThreePopOne()" src="/season10/static/_content/23-click-1.png"/>
      <div id="23-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 23-pop-1" style="top:537px;left:52px;" src="/season10/static/_content/23-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:556px;left:73px;width:259px;height:41px;" onclick="hideOverlay('23-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:760px;left:759px;width:42px;height:42px;" onclick="hideOverlay('23-pop-1')"></div>
      </div>

      <img class="abs halfScale animatedpulse halfpulsetwo pointer 23-click-2" style="top:719px;left:51px;" onclick="showTwentyThreePopTwo()" src="/season10/static/_content/23-click-2.png"/>
      <div id="23-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 23-pop-2" style="top:163px;left:52px;" src="/season10/static/_content/23-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:722px;left:79px;width:42px;height:42px;" onclick="hideOverlay('23-pop-2')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg23Anim = new TimelineMax();
        }

        function showTwentyThreePopOne() {
          showOverlay('23-pop-1')
        }

        function closeTwentyThreePopOne() {
          hideOverlay('23-pop-1')
        }

        function showTwentyThreePopTwo() {
          showOverlay('23-pop-2')
        }

        function closeTwentyThreePopTwoOne() {
          hideOverlay('23-pop-2')
        }

        function onPageLeave() {
          pg23Anim.stop();
          closeTwentyThreePopOne();
          closeTwentyThreePopTwo();
        }
      `,
      "searchText": "INTRODUCING  DRIVING FORCE Harnessing the power of sport to educate young people on key environmental and social issues presents a huge opportunity to inspire the next generation of decision-makers while equipping them with the knowledge to drive positive change. That’s why, in Season 10, Formula E launched Driving Force, a sustainability education programme for young people globally.  CLICK TO READ MORE  CLICK TO READ ABOUT DRIVING FORCE  23  FORMULA EQUITY  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 24-click" style="top:710px;left:592px;" onclick="showTwentyFourPopOne()" src="/season10/static/_content/24-click.png"/>
      <div id="24-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 24-pop-1" style="top:165px;left:52px;" src="/season10/static/_content/24-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:740px;left:79px;width:42px;height:42px;" onclick="hideOverlay('24-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg24Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentyFourPopOne() {
          showOverlay('24-pop-1')
        }

        function closeTwentyFourPopOne() {
          hideOverlay('24-pop-1')
        }

        function onPageLeave() {
        pg24Anim.stop();
        closeTwentyThreePopOne();
        }
      `,
      "searchText": "CREATING OPPORTUNITIES WITHIN FORMULA E Our Formula Equity pillar works in tandem with our internal Equity, Diversity and Inclusion strategy to create pathways into motorsport for individuals historically excluded from the industry.  We partnered with the 93% Club, a charity focused on improving opportunities for those from state-educated backgrounds, to further enhance these efforts in Season 11.  With a 64% response rate, the survey informed our targeted action plans, including recruitment webinars and the implementation of an applicant tracking system  FORMULA EQUITY  Additionally, we established the Formula E EDI Charter to solidify our commitment. The ‘Leading the Charge’ programme, designed for managers, helps identify progression gaps for individuals with protected characteristics and works to remove barriers to their advancement. In Season 10, we also began efforts to improve socioeconomic diversity within the organisation. Our headquarters, located in Hammersmith, London, are strategically positioned to support social mobility, offering accessibility for employees from diverse socioeconomic backgrounds.  In Season 10, we made meaningful progress with key initiatives to advance our internal EDI goals, working in tandem with our external social impact initiatives. We launched our first full employee demographic survey, replacing assumptions with data to better understand areas for improvement.  24  that collects diversity data and ensures fair hiring through blind shortlisting.  CLICK TO READ ABOUT SUPPORTING EMPLOYEE-DRIVEN SOCIAL IMPACT  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg25Anim.stop();
        }
      `,
      "searchText": "4  FORMULA"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScale animatedpulse halfpulsetwo pointer 26-click" style="top:764px;left:708px;" onclick="showTwentySixPopOne()" src="/season10/static/_content/26-click.png"/>
      <div id="26-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 26-pop-1" style="top:237px;left:681px;" src="/season10/static/_content/26-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:753px;left:1196px;width:42px;height:42px;" onclick="hideOverlay('26-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg26Anim = new TimelineMax();
        }

        function showTwentySixPopOne() {
          showOverlay('26-pop-1')
        }

        function closeTwentySixPopOne() {
          hideOverlay('26-pop-1')
        }

        function onPageLeave() {
        pg26Anim.stop();
        closeTwentySixPopOne();
        }
      `,
      "searchText": "REFINED MAKING SURE OUR APPROACH STAYS ALIGNED WITH SCIENCE AND AHEAD OF THE CURVE Climate action and reducing our carbon footprint remained our top environmental priority. Season 10 marked a decade of progress, and we took significant steps toward our targets. We refined our carbon measurement methodology, incorporating more granular primary data – particularly from business travel across the 11 Formula E teams – resulting in a more robust calculation. Our Scope 1 and 2 greenhouse gas emissions dropped by 65%, driven by lower energy consumption and increased use of renewables at several race circuits.  26  FORMULA ENVIRONMENT  Since our inception, we have maintained net zero carbon status in line with the PAS 2060 standard, which requires rigorous measurement, reduction and mandatory offsetting, along with independent third-party audits and full transparency. We were the first sport to set a Science Based Target with the highest level of ambition, aligning with a 1.5°C pathway. This commitment aims to reduce our absolute Scope 1, 2 and 3 emissions by 45% by 2030, using our Season 5 baseline as a benchmark.  THIS SECTION OF THE REPORT In this section, we explore each of these areas in detail.  MEASUREMENT  REDUCTION  OFFSETTING  Our full  Our reduction  Reflecting  comprehensive  plan, and  on our  carbon audit  where we  key projects  for Season 10.  have made  to address our  progress over  unavoidable  the season.  emissions.  BUILDING ON A DECADE OF WORK  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale animatedpulse halfpulsetwo pointer 27-click" style="top:750px;left:52px;" onclick="showTwentySevenPopOne()" src="/season10/static/_content/27-click.png"/>
      <div id="27-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 27-pop-1" style="top:65px;left:50px;" src="/season10/static/_content/27-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:746px;left:69px;width:42px;height:42px;" onclick="hideOverlay('27-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      <div class="addContentLink" style="top:695px; left:1036px; width:222px; height:98px;">
        <a href="https://storage.googleapis.com/public-wayfinding/Season10_PAS2060_Formula%20E_JP%20Signed.docx%20(1).pdf" target="_blank"></a>
      </div>
      
      `,
      "script": `
        function onPageEnter() {
        pg27Anim = new TimelineMax();
        setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentySevenPopOne() {
          showOverlay('27-pop-1')
        }

        function closeTwentySevenPopOne() {
          hideOverlay('27-pop-1')
        }

        function onPageLeave() {
        pg27Anim.stop();
        closeTwentySevenPopOne();
        }
      `,
      "searchText": "OUR  CARBON IMPACT Our carbon footprint is measured in accordance with the Greenhouse Gas Protocol Corporate Accounting and Reporting Standard and through a Lifecycle Assessment model, which covers the environmental impacts of both race operations and our headquarters. Conducted annually, this analysis tracks our greenhouse gas emissions, identifies the key sources of environmental impact and highlights opportunities for further improvements in our planning and operations.  WHAT WE MEASURE  DOWNSTREAM SCOPE  UPSTREAM SCOPE  SCOPE  P urchased goods and services C apital goods  Owned vehicles  E lectricity Fuel and energy related  O wned  H eat  activities (not included in Scope 1 or 2)  infrastructure C ooling  U pstream transportation P urchased  and distribution  stream Waste generated in operations B usiness travel E mployee commuting  CLICK FOR SEASON 10 CARBON FOOTPRINT NUMBERS  27  FORMULA ENVIRONMENT  SCOPE  SEASON 10 SUSTAINABILITY REPORT  U pstream leased assets  D ownstream transportation and distribution P rocessing of sold products U se of sold products E nd-of-life treatment of sold products D ownstream leased assets Franchises I nvestments"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScale animatedpulse halfpulsetwo pointer 28-click" style="top:761px;left:552px;" onclick="showTwentyEightPopOne()" src="/season10/static/_content/28-click.png"/>
      <div id="28-pop-1" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 28-pop-1" style="top:317px;left:549px;" src="/season10/static/_content/28-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:746px;left:575px;width:42px;height:42px;" onclick="hideOverlay('28-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
        pg28Anim = new TimelineMax();
        }

        function showTwentyEightPopOne() {
          showOverlay('28-pop-1')
        }

        function closeTwentyEightPopOne() {
          hideOverlay('28-pop-1')
        }

        function onPageLeave() {
        pg28Anim.stop();
        closeTwentyEightPopOne();
        }

      `,
      "searchText": "OUR  REDUCTION  While we continued to reduce our carbon footprint compared to our Season 5 baseline, it increased by 11% compared to Season 9. This rise was primarily due to the transition from secondary assumptions to primary data for the business travel of the championship's 11 teams.  EFFORTS  Additionally, there was a slight increase in emissions from spectator travel and freight, driven by a different configuration of race locations compared to Season 9. We were able to reduce our Scope 1 and 2 emissions by reducing our electricity consumption at our headquarters and race locations, as well as increase the share of renewable energy at different circuits, including Tokyo, Misano, Monaco and London. Reducing our freight carbon footprint is a key priority for us. Through our partnership with our Official Logistics Partner DHL, we have developed a roadmap to further decrease these emissions. This strategy includes regional event clustering, reducing our reliance on air freight, using sustainable biofuels for road and ocean transport and using Sustainable Aviation Fuel (SAF), which reduces greenhouse gas emissions by at least 80% compared to traditional kerosene aviation fuel. In Season 10, we successfully used SAF for transporting freight between Berlin and Shanghai.  28  FORMULA ENVIRONMENT  CLICK TO READ ABOUT OUR STAFF TRAINING  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg29Anim.stop();
        }
      `,
      "searchText": "5  FORMULA"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
         pg30Anim = new TimelineMax();
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
        pg30Anim.stop();
        }
      `,
      "searchText": "VALUE BRINGING TOGETHER AN INFLUENTIAL ECOSYSTEM OF PARTNERS WITH COMMON AMBITIONS Progress doesn’t happen in isolation. We are part of an influential ecosystem of partners, teams and host cities that share our goals and challenges, all driven by a common ambition: to accelerate sustainable human progress.  THIS SECTION OF THE REPORT Explores how we work together for better futures.  Our mission is to create value for our Teams, Partners, People and Stakeholders. Through our platform, we generate ideas and launch projects that can be scaled to reduce environmental impact and drive social progress. Collaboration is at the heart of this effort, with key stakeholders playing a vital role.  PARTNERS  TEAMS  CITIES  Collaborating with  Providing a platform  Offering thought  a diverse range of  to innovate, activate  leadership and  organisations to  ideas and push  networking  develop and test  the boundaries of  opportunities to tackle  sustainable solutions.  sustainability.  urban challenges related to climate action and inclusion.  30  FORMULA ECOSYSTEM  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 31-click" style="top:721px;left:21px;" onclick="showThirtyOnePopOne()" src="/season10/static/_content/31-click.png"/>
      <div id="31-pop-1-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 31-pop-1-1" style="top:36px;left:50px;" src="/season10/static/_content/31-pop-1-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('31-pop-1-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:1096px;width:131px;height:64px;" onclick="showThirtyOnePopOneTwo('31-pop-1-2')"></div>
      </div>

      <div id="31-pop-1-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 31-pop-1-2" style="top:36px;left:50px;" src="/season10/static/_content/31-pop-1-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:75px;left:1184px;width:42px;height:42px;" onclick="hideOverlay('31-pop-1-2')"></div>
        <div class="abs contentLinkNone pointer" style="top:703px;left:953px;width:131px;height:64px;" onclick="showThirtyOnePopOne('31-pop-1-1')"></div>
      </div>      

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 31-click" style="top:721px;left:458px;" onclick="showThirtyOnePopTwo()" src="/season10/static/_content/31-click.png"/>
      <div id="31-pop-2" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 31-pop-2" style="top:36px;left:50px;" src="/season10/static/_content/31-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:66px;left:1178px;width:42px;height:42px;" onclick="hideOverlay('31-pop-2')"></div>
      </div>
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 31-click" style="top:721px;left:891px;" onclick="showThirtyOnePopThree()" src="/season10/static/_content/31-click.png"/>
      <div id="31-pop-3" class="standardTransition contentOverlay hidden noclick">
      <img class="abs halfScale 31-pop-3" style="top:36px;left:50px;" src="/season10/static/_content/31-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:66px;left:1178px;width:42px;height:42px;" onclick="hideOverlay('31-pop-3')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showThirtyOnePopOne() {
          closeThirtyOnePopOneTwo()
          showOverlay('31-pop-1-1')
        }

        function closeThirtyOnePopOneOne() {
          hideOverlay('31-pop-1-1')
        }

        function showThirtyOnePopOneTwo() {
          closeThirtyOnePopOneOne()
          showOverlay('31-pop-1-2')
        }

        function closeThirtyOnePopOneTwo() {
          hideOverlay('31-pop-1-2')
        }

        function showThirtyOnePopTwo() {
          showOverlay('31-pop-2')
        }

        function closeThirtyOnePopTwo() {
          hideOverlay('31-pop-2')
        }

        function showThirtyOnePopThree() {
          showOverlay('31-pop-3')
        }

        function closeThirtyOnePopThree() {
          hideOverlay('31-pop-3')
        }

        function onPageLeave() {
          pg31Anim.stop();
          closeThirtyOnePopOne();
          closeThirtyOnePopTwo();
          closeThirtyOnePopThree();
        }
      `,
      "searchText": "REDEFINING THE STATUS QUO  31  We partner with brands that are transforming their industries and redefining the status quo for a more sustainable society.  RETHINKING LOGISTICS WITH DHL  REDUCING EMISSIONS WITH AGGREKO  BRINGING WASTE, ART AND INNOVATION TOGETHER WITH JULIUS BAER  CLICK TO READ  CLICK TO READ  CLICK TO READ  FORMULA ECOSYSTEM  SEASON 10 SUSTAINABILITY REPORT"
      }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 32-click" style="top:732px;left:132px;" onclick="showThirtyTwoPopOne()" src="/season10/static/_content/32-click.png"/>
      <div id="32-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 32-pop-1" style="top:48px;left:50px;" src="/season10/static/_content/32-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:77px;left:1178px;width:41px;height:42px;" onclick="hideOverlay('32-pop-1')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 32-click" style="top:732px;left:786px;" onclick="showThirtyTwoPopTwo()" src="/season10/static/_content/32-click.png"/>
      <div id="32-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 32-pop-2" style="top:48px;left:50px;" src="/season10/static/_content/32-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:77px;left:1178px;width:41px;height:42px;" onclick="hideOverlay('32-pop-2')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }


        function showThirtyTwoPopOne() {
          showOverlay('32-pop-1')
        }

        function closeThirtyTwoPopOne() {
          hideOverlay('32-pop-1')
        }

        function showThirtyTwoPopTwo() {
          showOverlay('32-pop-2')
        }

        function closeThirtyTwoPopTwo() {
          hideOverlay('32-pop-2')
        }

        function onPageLeave() {
          pg32Anim.stop();
          closeThirtyTwoPopOne();
          closeThirtyTwoPopTwo();
        }

      `,
      "searchText": "A CREATIVE APPROACH TO  IMPACT  32  Envision Racing and Andretti earned our Climate Champion Award and Community Champion Award, respectively, for their creative and impactful contributions to environmental and social progress.  ENVISION BRINGS THE PROBLEM OF E-WASTE TO THE MASSES  ANDRETTI GIVES ITS PLATFORM TO EMERGING ARTISTS  CLICK TO READ  CLICK TO READ  FORMULA ECOSYSTEM  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 33-click" style="top:142px;left:790px;" onclick="showThirtyThreePopOne()" src="/season10/static/_content/33-click.png"/>
      <div id="33-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-1" style="top:0px;left:666px;" src="/season10/static/_content/33-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:74px;left:1178px;width:41px;height:42px;" onclick="hideOverlay('33-pop-1')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 33-click" style="top:420px;left:802px;" onclick="showThirtyThreePopTwo()" src="/season10/static/_content/33-click.png"/>
      <div id="33-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-2" style="top:0px;left:666px;" src="/season10/static/_content/33-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:74px;left:1178px;width:41px;height:42px;" onclick="hideOverlay('33-pop-2')"></div>
      </div>

      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 33-click" style="top:701px;left:791px;" onclick="showThirtyThreePopThree()" src="/season10/static/_content/33-click.png"/>
      <div id="33-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-3" style="top:0px;left:666px;" src="/season10/static/_content/33-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:74px;left:1178px;width:41px;height:42px;" onclick="hideOverlay('33-pop-3')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }


        function showThirtyThreePopOne() {
          showOverlay('33-pop-1')
        }

        function closeThirtyThreePopOne() {
          hideOverlay('33-pop-1')
        }

        function showThirtyThreePopTwo() {
          showOverlay('33-pop-2')
        }

        function closeThirtyThreePopTwo() {
          hideOverlay('33-pop-2')
        }

        function showThirtyThreePopThree() {
          showOverlay('33-pop-3')
        }

        function closeThirtyThreePopThree() {
          hideOverlay('33-pop-3')
        }

        function onPageLeave() {
          pg33Anim.stop();
          closeThirtyThreePopOne();
          closeThirtyThreePopTwo();
          closeThirtyThreePopThree();
        }

      `,
      "searchText": "SHAPING  SUSTAINABLE CITIES  EXPLORING NEW ENERGY MARKETS CLICK TO READ  Change.Accelerated.Live (CAL) is our sustainability forum and thought leadership platform, bringing together industry and political leaders to explore new strategies in sustainability and innovation. The event drives positive change across sports, business and society, highlighting the critical role of cities and municipalities in adopting sustainable solutions.  RACE-TO-ROAD TECHNOLOGY SHOWCASED CLICK TO READ  As many cities set ambitious targets, their leadership is essential in protecting the environment while creating new opportunities for growth and inclusivity. During the Season 10 programme of CAL, we explored some of these opportunities.  IMAGINING SUSTAINABLE URBAN ENVIRONMENTS CLICK TO READ  33  FORMULA ECOSYSTEM  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:418px; left:1192px; width:84px; height:85px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg34Anim.stop();
        }
      `,
      "searchText": "6  SUMMARY AND"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg35Anim.stop();
        }
      `,
      "searchText": "LOOKING SEASON 10 MARKED A MILESTONE, CELEBRATING A DECADE OF PROGRESS IN ELECTRIC RACING. Bringing together leading automotive manufacturers, global brands and world-class drivers, the championship featured 16 races across 10 major cities worldwide. Over the past 10 seasons, the series has become a platform for innovation and collaboration, continually redefining what sustainable  Building on this legacy, Season 10 introduced initiatives aimed at tackling urgent societal challenges. With climate action and nature stewardship at its core, the season human development, demonstrating how elite competition can drive real-world impact. To highlight this progress, we have once again included a GRI content index. This structured summary maps Standards, making it easy for readers to locate key transparency and comparability.  35  SUMMARY AND GRI INDEX  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `

      <!--- scrollable table --->

      <div id="scrollable-container" class="abs scroll-container" style="width: 1100px; height: 383px; top: 315px; left: 67px; overflow-y: scroll;">
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-1.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-2.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-3.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-4.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-5.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-6.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-7.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-8.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-9.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-10.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-11.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-12.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-13.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-14.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-15.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-16.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-17.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-18.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-19.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-20.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-21.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-22.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-23.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-24.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season10/static/_content/pdf-25.jpg"/>
      </div>
      <div class="slidecontainer">
        <input type="range" min="1" max="144" value="1" step="1" class="slider" id="myRange" style="transform: rotate(180deg);">
      </div>
        
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>


      <!--- clickable tab --->
      
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 36-tab" style="top:764px;left:226px;" src="/season10/static/_content/36-box.png"/>
      <img class="abs halfScaleC animatedpulse halfpulsetwo pointer 36-tab" style="top:783px;left:267px;" src="/season10/static/_content/36-click-tab.png"/>

      <div class="contentLinkNone" style="top:784px;left:442px;width:413px;height:28px">
        <a href="https://sustainabilityreport.fiaformulae.com/static/_thumbs/season10/static/_content/gri_content_index_table_final.pdf" target="_blank"></a>
      </div>
            
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:441px; left:1266px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          var scroll = document.getElementById("myRange");
          var panel = document.getElementById("scrollable-container");

          scroll.oninput = function () {
            var total = panel.scrollHeight - panel.offsetHeight;
            var percentage = total*(this.value/100);
            panel.scrollTop = percentage;
          };

          panel.onwheel = function(e){
          console.log(e)
            if (e.deltaY < 0){
              scroll.stepDown(1);
            }else{
              scroll.stepUp(1);
            }
          };

          pg36Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg36Anim.stop();
        }
      `,
      "searchText": "CONTENT INDEX GRI CONTENT INDEX  GRI  for the period 28th January 2023 – 14th August 2024 with reference to the GRI Standards.  for the period 28th January 2023 – 14th August 2024 with reference to the GRI Standards.  SCROLL TO READ TABLE GRI STANDARDS  DISCLOSURE  LOCATION  bn2-1 Organizational details  2-1-a Organisation legal name – Formula E Operations Limited 2-1-b Ownership and legal form On 20th February 2013, Formula E Operations Limited was incorporated under the Companies  General disclosures GRI 2: General Disclosures 2021  Formula E Holdings Limited (Hong Kong). Formula E Operations Limited and Formula E Race Operations, 2-1-d Countries of operations  Hong Kong.  : Formula E Holdings Limited, Level 54, Hopewell Centre, 183 Queen’s Road East, Formula E Mexico Race Operations S De RL DE CV, Avenida Ejercito Nacional,  : 28 Old Rudnick Lane, Dover, Delaware, US, 19901 : Alameda Santos 1293, Sao Paulo, 01419-904 Sao Paulo, Brazil e: c/o Ark Outsourcing KK, 4-3-5-704, Ebisu, Shibuya-ku, Tokyo, Japan period, frequency and contact point  1  36  GRI INDEX  SUMMARY AND GRI INDEX  – 1st October 2023 to 30th September 2024 : 28th January 2023 – 14th August 2024 2-3-c Publish date – April/May 2025 – sustainabilty@fiaformulae.com  CLICK TO DOWNLOAD FULL TABLE SEASON 10 SUSTAINABILITY REPORT  SEASON 10 SUSTAINABILITY REPORT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }

    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            console.log(obj.number)
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            console.log("PREDEC", predec, typeof(predec));
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            console.log("NEWSTR", newstr, typeof(newstr));
            // console.log({newstr})
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }

    function mailChimpSubmit(){
      $('#mc-embedded-subscribe-form').submit(function (e) {
        var that = $(this);
        var mailchimpSubmit = $(this).find('input[type=submit]');
        var errorResponse = $('#mce-error-response');
        var successResponse = $('#mce-success-response');

        e.preventDefault();

        $.ajax({
          method: 'GET',
          url: that.attr('action'),
          data: that.serialize(),
          dataType: 'jsonp',
          success: function(data) {
            console.log('AJAX SUCCESS')
          // If there was an error then show the error message.
            if (data.result === 'error') {
              console.log('AJAX ERROR')
              // If the error has an error code at front then alter the message to not include the error code and hyphen.
              if(data.msg.indexOf('0') === 0) {
                data.msg = data.msg.slice(3);
              }
              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);
            }
            // If success then show message
            else {
              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);
            }
          }
        });
      });
    }
  `,
  "mobilePages": null,
  "mobileTemplate": null,
}



// WEBPACK FOOTER //
// ./src/document.js